import { render } from "./IconShare.vue?vue&type=template&id=4ded9ec0"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconShare.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ded9ec0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ded9ec0', __exports__)) {
    api.reload('4ded9ec0', __exports__)
  }
  
  module.hot.accept("./IconShare.vue?vue&type=template&id=4ded9ec0", () => {
    api.rerender('4ded9ec0', render)
  })

}


export default __exports__